export const formatMoney = (value: number, includeFraction = true): string => {
  if (typeof value !== 'number') return '';

  const formatter = new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
    minimumFractionDigits: includeFraction ? 2 : 0,
    // @ts-ignore ignore while still targeting es6 in tsconfig.json
    currencyDisplay: 'symbol', // do not use narrowSymbol due to iOS compatability issues
  });
  const formattedValue = formatter.format(value);
  return formattedValue.replace(/[a-zA-Z]/, '');
};
